import { render, staticRenderFns } from "./CourseYoutube.vue?vue&type=template&id=6d03a1f8&scoped=true&"
import script from "./CourseYoutube.vue?vue&type=script&lang=js&"
export * from "./CourseYoutube.vue?vue&type=script&lang=js&"
import style0 from "./CourseYoutube.vue?vue&type=style&index=0&id=6d03a1f8&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d03a1f8",
  null
  
)

component.options.__file = "CourseYoutube.vue"
export default component.exports